import {
  LeaderboardUser,
  LeaderboardUserBase,
} from "model/Leaderboard/User/LeaderboardUser";
import { mapCombinedLeaderboardUser } from "./FsCombinedLeaderboardUser";
import { mapSegmentLeaderboardUser } from "./FsSegmentLeaderboardUser";
import {
  FsLeaderboardUser,
  FsLeaderboardUserBase,
} from "db/model/leaderboard/FsLeaderboardUser";
import { isFsCombinedLeaderboardUser } from "db/model/leaderboard/FsCombinedLeaderboardUser";
import { isFsSegmentLeaderboardUser } from "db/model/leaderboard/FsSegmentLeaderboardUser";
import { isFsTournamentLeaderboardUser } from "db/model/leaderboard/FsTournamentLeaderboardUser";
import { mapTournamentLeaderboardUser } from "./FsTournamentLeaderboardUser";

const mapLeaderboardUserBase = (
  fsModel: FsLeaderboardUserBase,
  uid: string
): LeaderboardUserBase | undefined => {
  if (fsModel.points === undefined || !fsModel.rank || !fsModel.sort) {
    return undefined;
  }

  return {
    uid,
    points: fsModel.points,
    rank: fsModel.rank,
    sort: fsModel.sort,
  };
};

export const mapLeaderboardUser = (
  fsModel: FsLeaderboardUser,
  uid: string
): LeaderboardUser | undefined => {
  const base = mapLeaderboardUserBase(fsModel, uid);
  if (!base) {
    return undefined;
  }

  if (isFsCombinedLeaderboardUser(fsModel)) {
    return mapCombinedLeaderboardUser(fsModel, base);
  }

  if (isFsSegmentLeaderboardUser(fsModel)) {
    return mapSegmentLeaderboardUser(fsModel, base);
  }

  if (isFsTournamentLeaderboardUser(fsModel)) {
    return mapTournamentLeaderboardUser(fsModel, base);
  }

  return undefined;
};
